/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/

export const getApiEndpoint = (path: string = ''): string => {
  const apiEndpoint = `${window.location.origin}/api`; // (REACT_APP_API_ENDPOINT as string) || `${window.location.origin}/api`;
  return `${apiEndpoint}${path}`;
};
